export default __webpack_public_path__ + "img/7a265378744b22eef30b87261ea6aaf9.jpg";